import { render, staticRenderFns } from "./DedicatedDetail.vue?vue&type=template&id=5363d75a&scoped=true"
import script from "./DedicatedDetail.vue?vue&type=script&lang=js"
export * from "./DedicatedDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5363d75a",
  null
  
)

export default component.exports